// extracted by mini-css-extract-plugin
export default {"filters":"reportfilters_filters__2AvH7"};